import { createStore, applyMiddleware, compose } from 'redux';
import { rootReducer } from '../Reducers/rootReducer';
import thunk from 'redux-thunk';
import { AuthActions } from '../Reducers/authReducer';
import { CategoriesActions } from '../Reducers/categoriesReducer';
import { ChartsActions } from '../Reducers/chartsReducer';
import { NewProductActions } from '../Reducers/newProductReducer';
import { OrdersActions } from '../Reducers/ordersReducer';
import { PaginationActions } from '../Reducers/paginationReducer';
import { ProductsActions } from '../Reducers/productsReducer';
import { SettingsActions } from '../Reducers/settingsReducer';
import { UserActions } from '../Reducers/userReducer';
import { AdminsActions } from '../Reducers/adminsReducer';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}
const composeEnhancers = (process.env.NODE_ENV === 'development')
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  : compose;


export type AppState = ReturnType<typeof rootReducer>;
export type AppActions =
  AuthActions
  | CategoriesActions
  | ChartsActions
  | NewProductActions
  | OrdersActions
  | PaginationActions
  | ProductsActions
  | SettingsActions
  | UserActions
  | AdminsActions;

export const store = createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));